<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getList,
	del,
	update,
	add,
	getDetails,
	getRule,
	getUser
} from "@/api/tracker/costRule";
import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getChargingType } from "@/api/double/list";
import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
export default {
  name: "costRule",
	components:{
		cTable
	},
  async created() {
		let baoguan_agent = (await getAgent()).data.payload.rows;
		let allClient = (await getAllClient()).data.payload.rows;
		let config = (await getConfig()).data.payload;
		this.SubjectCost = (await getSubjectCost({ pid: 0 })).data.payload
		this.currencyList = config.currency;
		this.bubble = config.bubble;
		this.unit = config.unit;
		this.header.searchs.forEach(async (item) => {
		  if (item.key === "agent_id") item.options = baoguan_agent;
		  if (item.key === "client_id") item.options = allClient;
		});
  },
  methods: {},
  data() {
    let that = this;
    return {
			unit:[],
			bubble:[],
			currencyList:[],
			SubjectCost:[],
      methods: {
        list: getList,
        del,
        update,
        add,
        getDetails,
				getRule,
				getUser
      },
      modals: {
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
							row.details = this.list
              this.$page.handleRequestMethods(row.id?'update':'add', row, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 80,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "10px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
							title: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							charge_type: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
							  },
							],
							user_type: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
							  },
							],
							user_id: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
							  },
							],
            },
          },
          grid: [
            {title:12,charge_type:12},
            {user_type:12,user_id:12},
            {remarks:24},
          ],
          fields: [
            {
              key: "title",
              name: this.$t("rule")+this.$t("alipay_name"),
              component: "Input",
              placeholder:this.$t("rule")+this.$t("alipay_name")
            },
           
            {
              key: "user_type",
              name: () => this.$t("cope") + this.$t("type"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("cope") +
                  this.$t("type")
                );
              },
              options: [
								{label:this.$t('agentT'),value:1},
								{label:this.$t('User'),value:2}
							],
							optionsObj:{},
							methods:{
								'on-change'({value,field,fields}){
									if(field.optionsObj && field.optionsObj[value]){
										fields.find(t=>{
											if(t.key === 'user_id'){
												t.options = field.optionsObj[value]
												return true
											}
										})
									}
									this.$page.handleRequestMethods('getUser',{type:value}).then(res=>{
										field.optionsObj[value] = res.payload
										fields.find(t=>{
											if(t.key === 'user_id'){
												t.options = res.payload
												return true
											}
										})
									})
								}
							}
            },
						{
						  key: "user_id",
						  name: () => this.$t("cope") + this.$t("object"),
						  component: "Select",
						  placeholder() {
						    return (
						      this.$t("select") +
						      this.$t("cope") +
						      this.$t("object")
						    );
						  },
						  options: [],
						},
            {
              key: "charge_type",
              name: () => this.$t("expType"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("expType")
                );
              },
              options: [
            		{label:this.$t('extract'),value:1},
            		{label:this.$t('packing'),value:2}
            	],
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
					table:{
						config:{
							height:550,
							resize:false
						},
						fields:[
							{
							  name: () => this.$t("expense"),
							  key: "expense_item",
							  minWidth: 120,
							  component: "Cascader",
							  placeholder() {
							    return this.$t("select") + this.$t("expense");
							  },
							  options: [],
							  methods: {
									list:({field})=>{
										field.options = this.SubjectCost
									},
							    async loadData({ item, callback }) {
										console.log('chufa');
							      item.loading = true;
							      item.children = (
							        await getSubjectCost({ pid: item.value })
							      ).data.payload;
							      item.loading = false;
							      callback();
							    },
							  },
							},
							{
								name: () => this.$t("calculation") + this.$t("currency_t"),
								key: "currency",
								component: "Select",
								placeholder() {
									return (
										this.$t("select") + this.$t("calculation") + this.$t("currency_t")
									);
								},
								options: [],
								methods:{
									list:({field})=>{
										field.options = this.currencyList;
									}
								}
							},
							{
							  name: () => this.$t("billing_price"),
							  key: "price",
							  component: "InputNumber",
							  placeholder() {
							    return this.$t("enter") + this.$t("billing_price");
							  },
							},
							{
							  name: () => this.$t("expType"),
							  key: "unit",
							  component: "Select",
							  placeholder() {
							    return this.$t("select") + this.$t("expense");
							  },
							  options: [],
							  bind: {
							    transfer: true,
							  },
								methods:{
									list:({field})=>{
										field.options = this.unit;
									}
								}
							},
							{
							  name: () => this.$t("bubble_weight"),
							  key: "bubble",
							  component: "Select",
							  placeholder() {
							    return this.$t("select") + this.$t("bubble_weight");
							  },
							  options: [],
							  bind: {
							    transfer: true,
							  },
								methods:{
									list:({field})=>{
										field.options = this.bubble;
									}
								}
							},
							{
							  name: () => this.$t("Remarks"),
							  key: "remarks",
							  component: "Input",
							  placeholder() {
							    return this.$t("enter") + this.$t("Remarks");
							  },
							},
							{
							  type: "btns",
							  width: 150,
							  name: () => this.$t("operation"),
							  fixed: "right",
							  list: [
							    {
							      name: () => this.$t("add"),
							      type: "add",
							      fnName: "add",
							      bind: {
							        type: "success",
							      },
										
							    },
							    {
							      name: () => this.$t("delete"),
							      type: "delete",
							      fnName: "deleteFun",
							      bind: {
							        type: "error",
							      },
										disabled(){
											return this.$modal.list.length === 1
										}
							    },
							  ],
							  methods: {
							    async add({ rowIndex }) {
										this.getModal('add').list.splice(rowIndex+1,0,{
											expense_item:[],
											currency:'',
											price:0,
											unit_name:'',
											bubble:'',
											remarks:'',
										})
							    },
							    deleteFun({ rowIndex }) {
										this.getModal('add').list.splice(rowIndex,1)
							    },
							  },
							},
						]
					}
        },
      },
      header: {
        searchs: [
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            config: { label: "account", value: "id" },
          },
					{
					  key: "agent_id",
					  component: "Select",
					  placeholder() {
					    return this.$t("select") + this.$t("agentT");
					  },
					  clearable: true,
					  options: [],
					  bind: {
					    style: "width:150px",
					  },
						config: {
						  label: "agent_name",
						  value: "id",
						},
					},
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   bind: {
          //     type: "textarea",
          //     rows: 1,
          //   },
          //   component: "Input",
          // },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              fnName: "add",
              type: "add",
              bind: {
                type: "primary",
              },
							id:1257
            },
          ],
          methods: {
          	add(){
          		this.getModal('add').open({},function(){
								this.list.push({
									expense_item:[],
									currency:'',
									price:0,
									unit_name:'',
									bubble:'',
									remarks:'',
								})
          			this.setTitle(this.$t("add"));
          		})
          	},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: this.$t("rule")+this.$t('alipay_name'),
          key: "title",
          minWidth: 120,
        },
				{
				  name: this.$t("cope")+this.$t('object'),
				  key: "user_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("cope")+this.$t('type'),
				  key: "user_type",
				  minWidth: 120,
				},
				{
				  name: this.$t("expType"),
				  key: "charge_type",
				  minWidth: 120,
				},
				{
				  name: this.$t("rule")+this.$t('Remarks'),
				  key: "remarks",
				  minWidth: 120,
				},
				{
				  name: this.$t("createTime"),
				  key: "create_time",
				  minWidth: 120,
				},
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
							id:1258
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
							id:1259
            },
          ],

          methods: {
            async updateFun({ row }) {
							this.handleRequestMethods('getDetails',row.id).then(res=>{
								this.getModal('add').open(res.payload,function(){
									if(res.payload.user_type){
										let user_type = res.payload.user_type
										this.$page.handleRequestMethods('getUser',{type:user_type}).then(res=>{
											this.fields.forEach(t=>{
												if(t.key === 'user_id'){
													t.options = res.payload
												}
												if(t.key === 'user_type'){
													t.optionsObj[user_type] = res.payload
												}
											})
										})
									}
									if(res.payload.details.length)this.list = res.payload.details
									else this.list = [{
										expense_item:[],
										currency:'',
										price:0,
										unit_name:'',
										bubble:'',
										remarks:'',
									}]
									this.$nextTick(()=>{
										
										this.$forceUpdate()
									})
									this.setTitle(this.$t("update"));
								})
							})
						 
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  ":" +
                  row.title +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
